export const GEO_API_KEY = 'AIzaSyB0seqGwnfcfjeYI01I7qHHM9dAR6A_9lA'; // Chave GEO GOOGLE